<template>
    <div>
        <div>
            <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求列表'},{title:'新增采购需求'}]"/>
            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2" style="padding:0">
                                        <div class="h-formLine weekplandetail33">
                                            <el-form :model="cai" label-position="right" ref="cai" :inline="true"
                                                     :rules="rules"
                                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                                <el-form-item label="需求来源" class="h-elformWrap-2" prop="euType">
                                                    <el-select v-model="cai.euType" :v="cai.euType" placeholder="请选择"
                                                               @change="customerType(cai.euType)">
                                                        <el-option v-for="(item) in options2"
                                                                   :key="item.code"
                                                                   :label="item.name"
                                                                   :value="item.code">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="客户名称" class="h-elformWrap-2" v-show="!benren">
                                                    <el-input v-model="cai.euName" :v="cai.euName" readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName"
                                                              v-show="benren">
                                                    <el-select v-model="cai.euName" :v="cai.euName" filterable remote
                                                               placeholder="请输入"
                                                               :remote-method="showFormList" @change="showForm">
                                                        <el-option v-for="(item) in EuName"
                                                                   :key="item.usercode"
                                                                   :label="item.userName"
                                                                   :value="item.userName">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode"
                                                              v-show="benren">
                                                    <el-input v-model="customer.areaCode" :v="customer.areaCode"
                                                              placeholder="自带出" readonly>
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode"
                                                              v-show="benren">
                                                    <el-input v-model="customer.channelCode"
                                                              :v="customer.channelCode" placeholder="自带出"
                                                              readonly>
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item label="部门/科室" class="h-elformWrap-2" prop="department"
                                                              v-show="benren">
                                                    <el-input v-model="cai.department"
                                                              :v="cai.department" placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName"
                                                              v-show="benren">
                                                    <el-input v-model="cai.contactuserName"
                                                              :v="cai.contactuserName"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone"
                                                              v-show="benren">
                                                    <el-input v-model="cai.telephone"
                                                              :v="cai.telephone" placeholder="请输入"
                                                              oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                                                </el-form-item>
                                                <el-form-item label="需求类型" class="h-elformWrap-2" prop="demandType">
                                                    <el-input value="采购需求" readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="采购类别" class="h-elformWrap-2" prop="cgType">
                                                    <el-select v-model="cai.cgType" placeholder="请选择"
                                                               @change="showcgStandard(cai.cgType)">
                                                        <el-option label="标准采购" value="标准采购"></el-option>
                                                        <el-option label="定向招投" value="定向招投"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="标准采购" class="h-elformWrap-2"
                                                              v-show="standard">
                                                    <el-select v-model="cai.cgStandard" placeholder="请选择">
                                                        <el-option label="技术领先" value="技术领先"></el-option>
                                                        <el-option label="价格领先" value="价格领先"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="供应商" class="h-elformWrap-2" v-show="gys">
                                                    <el-select v-model="cai.suppliername" :v="cai.suppliername"
                                                               filterable remote
                                                               placeholder="请输入"
                                                               :remote-method="showGYS">
                                                        <el-option v-for="(item) in Supplier"
                                                                   :key="item.usercode"
                                                                   :label="item.userName"
                                                                   :value="item.userName">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="需求背景及说明" class="h-elformWrap-1" prop="content">
                                                    <el-input v-model="cai.content" maxlength="100"
                                                              placeholder="请输入">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item label="上传附件" class="h-elformWrap-1" prop="caigouxuqiu">
                                                    <brupload
                                                            :refid='cai.id'
                                                            :reftype='caigouxuqiu'
                                                            uploadflag
                                                            delflag
                                                            v-model="cai.caigouxuqiu"
                                                            @filecallback="fileBack2"
                                                    >
                                                        <el-button size="small" type="text">上传</el-button>
                                                    </brupload>
                                                </el-form-item>
                                            </el-form>
                                            <div class="h-table h-mrt30 ljjtablepaddingscaigou" style="margin: 20px 20px 0 10px;">
                                                <div class="h-pieceTitle2 message">
                                                    <h1 class="h1">产品信息</h1>
                                                </div>
                                                <el-table
                                                        ref="multipleTable"
                                                        :data="productList"
                                                        :border="true"
                                                        stripe
                                                        style="width: 100%">
                                                    <el-table-column
                                                            type="index"
                                                            width="40"
                                                            label="#">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="levelcode"
                                                            label="产品大类"
                                                            width="200">
                                                        <template scope="scope">
                                                            <brselect class="h-tableInput" category="product_level" :v="scope.row.levelcode"
                                                                      v-model="scope.row.levelcode" @change="selectProductCg(scope.row)"
                                                                      style="width:1.7rem"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proname"
                                                            label="产品名称"
                                                            width="250">
                                                        <template slot-scope="scope">
                                                            <el-select class="h-tableInput" v-model="scope.row.proname"
                                                                       placeholder="--请选择--"
                                                                       filterable
                                                                       allow-create
                                                                       default-first-option
                                                                       @change="checkProduct(scope.row)"
                                                                       style="vertical-align:bottom">
                                                                <el-option
                                                                        v-for="(item,index2) in scope.row.optionsProductCg"
                                                                        :key="index2"
                                                                        :label="item.levelname"
                                                                        :value="item.levelname">
                                                                </el-option>
                                                            </el-select>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="xuniFlag"
                                                            label="产品类型">
                                                        <template scope="scope">
                                                            {{scope.row.xuniFlag|dictname('xuni_flag')}}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="procode"
                                                            label="产品编码">
                                                        <template slot-scope="scope">
                                                            <el-input v-model="scope.row.procode"
                                                                      class="h-tableInput"
                                                                      disabled
                                                                      style="vertical-align:bottom">
                                                            </el-input>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="number"
                                                            label="需求数量"
                                                            width="100">
                                                        <template slot-scope="scope">
                                                            <el-input class="h-tableInput"
                                                                    v-model.number="scope.row.number"
                                                                    placeholder="数量"
                                                                    oninput="value=value.replace(/[^\d]/g, '')"
                                                                    maxlength="10">
                                                            </el-input>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="resDescribe" label="产品描述" width="400">
                                                        <template slot-scope="scope">
                                                            <el-input class="h-tableInput" v-model="scope.row.resDescribe" maxlength="100"
                                                                      placeholder="产品描述"></el-input>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="操作" fixed="right" width="100">
                                                        <template slot-scope="scope">
                                                           <el-button
                                                                    type="text"
                                                                    class="h-tableLink h-btn"
                                                                    width="200"
                                                                    @click="deleteThis(scope.$index)">
                                                                删除
                                                            </el-button>
															<!-- <div class="l-operationBox">
																<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.$index)"></span>
															</div> -->
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <div class="h-tableAdd" style="background-color: rgb(94, 182, 233);">
                                                    <a @click="add">新增一行</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-txtCenter h-mrt60">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backL">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存
                    </el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="refer">确认提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                caigouxuqiu: "采购需求上传",
                productList: [
                    {
                        id: this.getUUid(),
                        optionsProductCg:[],
                        levelcode: '',
                        proname: '',
                        number: '',
                        resDescribe: '',
                    }
                ],
                Level: [],
                Supplier: [],
                gys: false,
                standard: false,
                benren: true,
                f: {
                    userName: null,
                },
                s: {
                    userName: null,
                },
                optionsProductCg: [],
                //用户类型 用户2 客户1
                options2: [{code: '1', name: '经销商'}, {code: '2', name: '用户'}, {code: '0', name: '内部需求'}],
                //客户全称列表
                EuName: [],
                number: 25,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                //带线表单
                cai: {
                    id: this.getUUid(),
                    endtime: null,
                    euCode: null,
                    euName: null,
                    euType: null,
                    CCName: null,
                    demandType: 1,
                    content: null,
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    caigouxuqiu: ''
                },
                customer: {
                    areaCode: null,
                    channelCode: null,
                },
                tableData: [],
                rules: {
                    endtime: [{required: true, message: '请选择需求截止时间', trigger: 'blur'}],
                    euType: [{required: true, message: '请选择需求来源', trigger: 'blur'}],
                    euName: [{required: true, message: '请选择客户全称', trigger: 'blur'}],
                    /*department: [{required: true, message: '请填写部门/科室', trigger: 'change'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'change'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'change'}],*/
                    content: [{required: true, message: '请填写需求背景及说明', trigger: 'blur'}],
                    cgType: [{required: true, message: '请选择采购类别', trigger: 'change'}],
                    caigouxuqiu:[{required: true, message: '请上传采购需求附件', trigger: 'blur'}],
                }
            }
        },
        created() {
            this.query();
        },
        methods: {
            selectProductCg(v) {
                v.proname = '';
                v.procode = '';
                v.xuniFlag = '';
                ss.ProService.product2OemSelect(v.levelcode).then(rd => {
                    v.optionsProductCg = rd;
                })
            },
            checkProduct(v) {
                // v.proname = v.optionsProductCg[i].levelname
                // v.procode = v.optionsProductCg[i].id
                if (v.optionsProductCg && v.optionsProductCg.length > 0) {
                    for (var i = 0; i < v.optionsProductCg.length; i++) {
                        if (v.proname != v.optionsProductCg[i].levelname) {
                            v.procode = ''
                            v.xuniFlag = 1
                        }
                    }
                    for (var i = 0; i < v.optionsProductCg.length; i++) {
                        if (v.proname == v.optionsProductCg[i].levelname) {
                            v.procode = v.optionsProductCg[i].id
                            v.xuniFlag = 0
                        }
                    }
                } else {
                    v.procode = ''
                    v.xuniFlag = 1
                }
            },
            //删除该行项目产品信息
            deleteThis(index) {
                this.productList.splice(index, 1);
            },
            getUUid() {
                return this.$util.getUuid();
            },
            add() {
                var list = {
                    id: '',
                    levelcode: '',
                    proname: '',
                    number: '',
                    resDescribe: '',
                    optionsProductCg:[]
                }
                this.productList.push(list);
            },
            query() {
                if (this.$route.query.id) {
                    this.cai.id = this.$route.query.id;
                    if (this.cai.id != null) {
                        ss.UserDemand.showprocuer(this.cai).then(rd => {
                            this.cai = rd;
                            this.productList = rd.productList;
                            if (this.cai.euType == 0) {
                                this.benren = false;
                                this.cai.euType = '内部需求';
                            } else {
                                this.cai.euType = this.$getDictName("userCareType", rd.euType);
                                this.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                                this.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                            }
                            if(this.cai.cgType=='标准采购'){
                                this.standard=true;
                                this.gys=false;

                            }else {
                                this.standard=false;
                                this.gys=true;
                            }
                        })
                    }
                } else {
                    this.cai.id = this.getUUid();
                }
            },
            showcgStandard(value) {
                if (value == '标准采购') {
                    this.cai.suppliername = '';
                    this.standard = true;
                    this.gys = false;
                } else {
                    this.cai.cgStandard='';
                    this.standard = false;
                    this.gys = true;
                }
            },
            fileBack2(v) {
                console.log(v)
                this.cai.caigouxuqiu = v.length;
            },
            //模糊查询供应商
            showGYS(value) {
                this.s.userName = value;
                ss.UserDemand.showGYS(this.s).then(rd => {
                    this.Supplier = rd;
                })
            },
            customerType(value) {
                if (value == 0) {
                    this.benren = false;
                    this.cai.euName = this._user.username;
                    this.cai.euCode = this._user.usercode;
                } else {
                    this.benren = true;
                    this.cai.euName = null;
                    this.customer.areaCode = null;
                    this.customer.channelCode = null;
                    this.cai.department = null;
                    this.cai.contactuserName = null;
                    this.cai.telephone = null;
                    this.EuName = null;
                }
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.f.userName = value;
                if (this.cai.euType == 1) {
                    ss.UserCare.agentOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.cai.euType == 2) {
                    ss.UserCare.customerOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            showForm() {
                for (var i = 0; i < this.EuName.length; i++) {
                    if (this.cai.euName == this.EuName[i].userName) {
                        this.cai.euCode = this.EuName[i].userCode;
                        this.cai.areaCode = this.EuName[i].areaCode;
                        this.cai.channelCode = this.EuName[i].channelCode;
                        this.customer.areaCode = this.$getDictName("YLRegion", this.EuName[i].areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", this.EuName[i].channelCode);
                        this.cai.contactuserName = this.EuName[i].contactuserName;
                        this.cai.department = this.EuName[i].department;
                        this.cai.telephone = this.EuName[i].telephone;
                    }
                }
            },
            zanCun() {
                if (this.cai.euType == null || this.cai.euName == null) {
                    this.$msg.msge("请先选择客户类型并填写客户全称！");
                } else {
                    if (this.cai.euType == "经销商") {
                        this.cai.euType = 1;
                    } else if (this.cai.euType == "用户") {
                        this.cai.euType = 2;
                    } else if (this.cai.euType == "内部需求") {
                        this.cai.euType = 0;
                    }
                    this.cai.demandType = 1;
                    this.cai.customer = null;
                    this.cai.productList = [];
                    this.productList.forEach(elements => {
                        if (elements.proname != null && elements.levelcode != null) {
                            this.cai.productList.push(elements);
                        }
                    });
                    ss.UserDemand.zanCun1(this.cai).then(rd => {
                        this.$msg.msgs("暂存成功");
                        this.$router.go(-1);
                    })
                }
            },
            refer() {
                var subflag = false;
                this.$refs['cai'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该采购需求?", () => {
                        console.log(this.cai,"11111111111111111111111")
                        if (this.cai.euType == "经销商") {
                            this.cai.euType = 1;
                        } else if (this.cai.euType == "用户") {
                            this.cai.euType = 2;
                        } else if (this.cai.euType == "内部需求") {
                            this.cai.euType = 0;
                        }
                        this.cai.customer = null;
                        this.cai.demandType = 1;
                        this.cai.productList = [];
                        this.productList.forEach(elements => {
                            if (elements.proname != null && elements.levelcode != null) {
                                this.cai.productList.push(elements);
                            }
                        });
                        console.log(this.cai,"222222222222222222222222222222")
                        ss.UserDemand.refer(this.cai).then(rd => {
                            this.$msg.msgs("提交成功");
                            this.$router.go(-1);
                        });
                    });
                }
            },
            backL() {
                this.$router.go(-1);
            }
        }
    }

</script>


<style>
    /* .h-formbLine1 .el-form-item__label {
        width: 21% !important;
    }

    .h-formbLine1 .el-form-item__content {
        width: 79% !important;
    }

    .h-formbLine1 .h-elformWrap-1 .el-form-item__label {
        width: 9.7% !important;
    }

    .h-formbLine1 .h-elformWrap-1 .el-form-item__content {
        width: 90.3% !important;
    } */
    .weekplandetail33 .h-formbLine .el-form-item__label {
        width: 42%;
        text-align: right;
    }

    .weekplandetail33 .h-formbLine .el-form-item__content {
        width: 58%;
    }

    .weekplandetail33 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail33 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail33 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 13%;
    }

    .weekplandetail33 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 87%;
    }
	.ljjtablepaddingscaigou .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddingscaigou .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
